import type { AxiosInstance } from "axios";
import { EventIdPublic } from "@shared/schemas/branded-id.schemas";

/**
 * Route owned here and imported by the admin api module, which reads it at the
 * admin tier. Two literals would let one tier keep working while the other 404s
 * after a route move.
 */
export function participantRosterUrl(eventIdPublic: EventIdPublic): string {
  return `/api/v1/events/${encodeURIComponent(EventIdPublic.unwrap(eventIdPublic))}/participants/roster`;
}

export function createParticipantRosterApi(apiClient: AxiosInstance) {
  // Returns unknown: the response is validated by the repo hook's schema parse,
  // not here. An axios response generic would be an unchecked cast, not validation.
  async function getParticipantRoster(
    eventIdPublic: EventIdPublic,
  ): Promise<unknown> {
    const response = await apiClient.get(participantRosterUrl(eventIdPublic));
    return response.data;
  }

  return { getParticipantRoster };
}
